const en = {
  login_or_signup: 'Login Or SignUp',
  enter_mobile_number: 'Enter your mobile number for Login or Signup',
  continue: 'Continue',
  server_error: 'Server Error',
  mobile_placeholder: 'Example: 09121111111',
  signup: 'Sign Up',
  verification_code: 'Verification code:',
  name: 'First name',
  last_name: 'Last name',
  gender: 'Gender',
  female: 'Female',
  male: 'Male',
  verification_sms_sent: 'Verification Code has been sent to {{mobile}}.',
  verify_mobile_number: 'Verify mobile number',
  click_for_changing_mobile: 'For changing mobile number, click here.',
  login: 'Login',
  mobile: 'Mobile Number',
  faq: 'FAQ',
  frequency_asked_question: 'frequently asked question',
  back: 'Back',
  time_to_resend_code: 'ثانیه تا ارسال دوباره کد',
  resend_code: 'ارسال مجدد کد'
}

export  default en
